export const colors = {
  BEKK_SORT: '#0e0e0e',
  BEKK_HVIT: '#ffffff',
  SOLOPPGANG: '#FFB88D',
  SOLOPPGANG_KONTRAST: '#FF8034',
  SOLOPPGANG_AKTIV: '#ff6e1a',
  SKYFRITT: '#B1E8FF',
  SKYFRITT_KONTRAST: '#43CBFF',
  SKYFRITT_AKTIV: '#33c5ff',
  SOLNEDGANG: '#FF9999',
  SOLNEDGANG_KONTRAST: '#FF5B5B',
  SOLNEDGANG_AKTIV: '#ff4d4d',
  SOLNEDGANG_SMILEY_AKTIV: '#ff1a1a',
  KVELD: '#E5B1FF',
  KVELD_KONTRAST: '#8E24C9',
  KVELD_AKTIV: '#8b22c3',
  NATT: '#6D7ABB',
  NATT_KONTRAST: '#162365',
  NATT_AKTIV: '#121d54',
  REGN: '#BCCEDD',
  REGN_KONTRAST: '#7E9CB9',
  REGN_AKTIV: '#7a9ab8',
  OVERSKYET: '#E7E7E7',
  OVERSKYET_KONTRAST: '#CECECE',
  OVERSKYET_AKTIV: '#B3B3B3',
  SOL: '#FFF2AD',
  SOL_KONTRAST: '#FFF02B',
  SOL_AKTIV: '#ffee00',
  GRØNN: '#A1F5E3',
  GRØNN_KONTRAST: '#16DBC4',
  GRØNN_AKTIV: '#15d1bb',
  GRØNN_SMILEY_AKTIV: '#10a291',
  BAKGRUNN: '#f5f5f5',
  SKYGGE: '#e1e1e1',
};

export const colorMap: Record<number, string> =  {
  0: colors.SOLOPPGANG,
  1: colors.SKYFRITT,
  2: colors.SOLNEDGANG,
  3: colors.GRØNN,
  4: colors.SOL,
  5: colors.KVELD,
  6: colors.NATT,
  7: colors.REGN,
  8: colors.OVERSKYET,
};

export const contrastColorMap: Record<number, string> =  {
  0: colors.SOLOPPGANG_KONTRAST,
  1: colors.SKYFRITT_KONTRAST,
  2: colors.SOLNEDGANG_KONTRAST,
  3: colors.GRØNN_KONTRAST,
  4: colors.SOL_KONTRAST,
  5: colors.KVELD_KONTRAST,
  6: colors.NATT_KONTRAST,
  7: colors.REGN_KONTRAST,
  8: colors.OVERSKYET_KONTRAST,
};

export const activeColorMap: Record<number, string> =  {
  0: colors.SOLOPPGANG_AKTIV,
  1: colors.SKYFRITT_AKTIV,
  2: colors.SOLNEDGANG_AKTIV,
  3: colors.GRØNN_AKTIV,
  4: colors.SOL_AKTIV,
  5: colors.KVELD_AKTIV,
  6: colors.NATT_AKTIV,
  7: colors.REGN_AKTIV,
  8: colors.OVERSKYET_AKTIV,
};